"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var router_2 = require("@angular/router");
var core_1 = require("@angular/core");
var compare_versions_component_1 = require("../Cms/compare-versions/compare-versions.component");
var dialog_1 = require("@angular/material/dialog");
var service_service_1 = require("../Services/service.service");
var WebFont = require("webfontloader");
var FooterComponent = /** @class */ (function () {
    function FooterComponent(router, dialog, service) {
        this.router = router;
        this.dialog = dialog;
        this.service = service;
        this.enableSubscription = false;
        this.enableCompareVersion = false;
        this.enableLetOurPros = false;
        this.enableAdvertiseWithUs = false;
        this.enableSubscription = service.enableSubscription;
        this.enableCompareVersion = service.enableCompareVersion;
        this.enableLetOurPros = service.enableLetOurPros;
        this.enableAdvertiseWithUs = service.enableAdvertiseWithUs;
    }
    FooterComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        //    throw new Error("Method not implemented.");
        WebFont.load({
            google: { families: ['Material Icons', 'Material Icons Outline'], },
            fontactive: function (familyName, fvd) {
                if (familyName = "Material Icons") {
                    _this.service.aplicationIsReady = true;
                }
            },
        });
    };
    Object.defineProperty(FooterComponent.prototype, "currentYear", {
        get: function () {
            return new Date().getFullYear();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "strBlogUrl", {
        get: function () {
            return this.service.advService.blogURL;
        },
        enumerable: true,
        configurable: true
    });
    FooterComponent.prototype.ngOnInit = function () {
        this.blogUrl = this.service.advService.blogURL;
        this.router.events.subscribe(function (evt) {
            if (!(evt instanceof router_2.NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    };
    FooterComponent.prototype.showCompareVersionsDialog = function () {
        var item = this.dialog.open(compare_versions_component_1.CompareVersionsComponent, {
            width: '70%',
            height: "762px",
            panelClass: "CompareVersionsComponent-panel",
            data: {
                isPopup: true
            }
        });
        item.componentInstance.isPopup = true;
        return false;
    };
    return FooterComponent;
}());
exports.FooterComponent = FooterComponent;
